import { API_URL } from '@/constants/config';
import { encodeQuery } from '~/modules/common/utils/routingUtils';

const base = API_URL + '/v3.5';

/**
 * Article Service
 *
 * @param {object} http axios instance from nuxt context
 * @param {object} cookies cookies from nuxt context
 */
export const yazioService = (http, cookies) => ({
  /**
   * Get Yazio Latest Feed Items
   */
  async getLatestYazioArticles() {
    const { data, pagination } = await http.$get(`${base}/articles?categoryId=5f5b94e4c081a13634207160&limit=10&author=true`);
    return { data, pagination };
  },
  /**
   * Get Yazio All Authors
   */
  async getAllYazioAuthors(limit = 150) {
    const { data, pagination } = await http.$get(`${base}/yazio/authors?page=1&limit=${limit}`);
    return { data, pagination };
  },
  /**
   * Get Author Info By Slug
   * @param {string} slug author slug
   */
  async getYazioAuthorBySlug(slug) {
    const { data, pagination } = await http.$get(`${base}/yazio/authors/${slug}`);
    return { data, pagination };
  },
  /**
   * Get Author Info By Slug
   * @param {string} id author id
   * @param {number} [param.page] page optional
   * @param {number} [param.limit] page optional
   */
  async getYazioAuthorArticles(userId, page = 1, limit = 49) {
    const queryParams = encodeQuery({ userId, page, limit, useHasNextPage: true, breadcrumb: true });
    const { data, pagination } = await http.$get(`${base}/articles${queryParams}`);
    return { data, pagination };
  },
});
